export default {
  state: {
    id: 0,
    name: '',
    realName: '',
    superAdmin: 0,
    superTenant: 0,
    tenantName: ''
  }
}
